import React from "react";
import Header from "../basic/Header";
import ContactUs from "../basic/contactUs";
import './professionalDevelopment.css';
import projectOrientedLearning from '../../images/projectOrientedLearning.jpg';
import interviewPreparation from '../../images/interviewPreparation.jpg';
import {Link} from "react-router-dom";
import CourseGrid from "../basic/CourseGrid";
import CourseSectionHeader from "../basic/CourseSectionHeader";
class ProfessionalDevelopment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            program: 'Professional Development',
            courses: [
                {
                    title: "Graduate Trainee",
                    subTitle: "(Project oriented Learning)",
                    imageUrl: projectOrientedLearning,
                    description: {
                        line1: "This program is aimed at learning through the project by mimicking the pattern followed in the software companies.",
                        line2: "By enrolling in this program, one will have the exposure to the standards and processes followed in the industry while working on a project itself."
                    },
                    duration: "8 Weeks",
                    mode: "Online",
                    price: "Rs. 5000",
                    enrollmentUrl: "/Professional_Development/Graduate_Trainee",
                    benefits: [
                        { text: "Live experience in Agile Development" },
                        { text: "Insights over Team work, Responsibility & Accountability" },
                        { text: "Hands-on working in industry experience (Real time project)" },
                        { text: "Project Completion Certificate" },
                        { text: "Mentoring by Industry Experts" },
                    ]
                },
                {
                    title: "Interview Preparation",
                    subTitle: "(Tech Interview Rounds)",
                    imageUrl: interviewPreparation,
                    description: {
                        line1: "To succeed in the tech interviews, you need to understand the expectations of the interviewer. This course will train you on solving problems, writing algorithms and analysing their solutions.",
                        line2: "It will also ensure rigorous and comprehensive preparation for the major tech giants like Google, Amazon, Microsoft, Samsung, Uber etc.,"
                    },
                    duration: "4-6 Months",
                    mode: "Online",
                    price: "Rs. 10,000",
                    enrollmentUrl: "/Professional_Development/Interview_Preparation",
                    benefits: [
                        { text: "Specially designed to target the Interviews" },
                        { text: "Frequent Topic-wise Test for your cognitive enhancements" },
                        { text: "Become an expert in DBMS, OS, System Design and many more" },
                        { text: "Live Doubt Support and Live mentor support" },
                    ]
                }
            ],
            edXCourses: [
                {
                    title: "How to Learn Online",
                    link: "https://www.edx.org/course/how-to-learn-online"
                },
                {
                    title: "Unlocking Your Employability",
                    link: "https://www.edx.org/course/unlocking-your-employability"
                },
                {
                    title: "Self-Assessment – Developing Your Strengths",
                    link: "https://www.edx.org/course/self-assessment-developing-your-strengths-2"
                },
                {
                    title: "Software Development Fundamentals",
                    link: "https://www.edx.org/course/software-development-fundamentals"
                },
                {
                    title: "Programming for Everybody (Getting Started with Python)",
                    link: "https://www.edx.org/course/programming-for-everybody-getting-started-with-pyt"
                },
                {
                    title: "Writing Professional Code",
                    link: "https://www.edx.org/course/writing-professional-code"
                },
                {
                    title: "Teamwork & Collaboration",
                    link: "https://www.edx.org/course/teamwork-collaboration"
                },
                {
                    title: "Design Thinking",
                    link: "https://www.edx.org/micromasters/ritx-design-thinking"
                }
            ]
        };
    }

    render() {
        return (
            <div>
                <Header title={"Professional Development"} subTitleText={"Professional development helps people to not only be competent in their profession, but also excel in it. It should be an ongoing process that continues throughout an individual's career. Actively pursuing professional development ensures that knowledge and skills stay relevant and up to date."}/>
                <div className="container">
                    <div className="row">
                        <div className="col-md-8">
                            <h2>Professional Development Programs</h2>
                            <hr />
                            <p>As a college student, your number one priority is to learn. What you need to realize early on in your college career is that your learning is not, and should not only be, located in the classroom. </p>
                            <p><strong>LEARN FROM EVERY EXPERIENCE!</strong> Better yet, learn from the successes and failures of others. To do that, you have to be intentional with your experience… and actually have learning experiences.</p>
                            <p>We provide various professional development programs for engineering students to make them industry ready and have working in Software Company like experience way before than they actually step into the Software Industry.</p>
                        </div>
                        <div className="col-md-4">
                            <ContactUs />
                        </div>
                    </div>
                </div>
                <hr className="col-md-8" style={{padding: "0px"}}/>
                <div className="container">
                    <CourseSectionHeader title={"Custom Designed Programs"} />
                    <div className="row">
                        { this.loadCourses() }
                    </div>
                </div>
                <hr className="col-md-8" style={{padding: "0px"}}/>
                <div className="container">
                    <CourseSectionHeader title={"Hand-picked Online Courses"} />
                    <CourseGrid
                        title={"edX Platform"}
                        link={"https://www.edx.org/"}
                        courses={this.state.edXCourses}
                    />
                </div>
            </div>
        );
    }

    loadCourses() {
        const enroll_base_url = "/enroll";
        return this.state.courses.map((course, id) =>
                <div className="col-md-4 mb-3" key={id}>
                    <div className="card h-100">
                        <img className="card-img-top" src={course.imageUrl} alt="" />
                        <div className="card-body">
                            <h4 className="card-title">{course.title}</h4>
                            <h5 className="card-subtitle">{course.subTitle}</h5>
                            <hr />
                            <p className="card-text">{course.description.line1}</p>
                            <p className="card-text">{course.description.line2}</p>
                        </div>
                        <div className="card-footer d-flex justify-content-center">
                            <Link to={{
                                pathname: enroll_base_url + course.enrollmentUrl,
                                state: {
                                    course: course,
                                    program: this.state.program
                                }
                            }} className="btn btn-info">Enroll Now</Link>
                        </div>
                    </div>
                </div>
        );
    }
}

ProfessionalDevelopment.propTypes = {};

export default ProfessionalDevelopment;
